import { Component } from '@angular/core';
import { BaseViewComponent } from '@common/classes/base-view';
import { IconKey } from '@common/classes/icons';
import { AdministrationPermissions } from '@common/classes/permissions';
import { CommonService as commonService } from '@common/services/common.service';
import { LanguageIds } from '@common/services/i18n.service';
import { ChangePasswordDialogComponent } from '../change-password-dialog/change-password-dialog.component';

@Component({
    selector: 'app-user-account-view',
    templateUrl: './user-account-view.component.html',
    providers: [commonService]
})
export class UserAccountViewComponent extends BaseViewComponent {
    override title = 'User Account';
    override entityName = 'UserAccount';
    override editPermission = AdministrationPermissions.User.Edit;

    icon: IconKey = 'faSolidCircleUser';
    currentLanguageId: string;

    constructor(common: commonService) {
        super(common);
        this.actionBar[0].items.push({
            label: 'Change Password',
            icon: 'faSolidBook',
            isVisible: () => this.canChangePassword(),
            onClick: () => this.changePassword()
        });
    }

    override async modelLoaded(): Promise<boolean> {
        if (!(await super.modelLoaded())) return false;
        this.currentLanguageId = this.model.languageId;

        return true;
    }

    override afterSave(model: any): Promise<void> {
        if (model.languageId !== this.currentLanguageId) {
            this.commonService.i18nService.changeDisplayLanguage(this.model.languageId.toLowerCase() as LanguageIds);
        }

        return super.afterSave(model);
    }

    canChangePassword() {
        return !this.editMode;
    }

    async changePassword() {
        const result = await this.dialogService.open({
            template: { content: ChangePasswordDialogComponent },
            dialogSettings: { width: '500px', height: 'auto' }
        });
        
        if (result) {
            // Password change was successful, reload the model
            this.loadModel();
        }
    }

    override saveCommand(customData?: {}): Promise<any> {
        this.entityName = 'User';
        return super.saveCommand(customData);
    }

    override getIdentifier = () => this.model.fullName;
}
